export default __webpack_public_path__ + "static/media/InsertImage.97330ac9.svg";